module.exports = __webpack_public_path__ + "img/2021_07-TCentral-IfMyPeoplePray2.f073ba92.jpg";